import React from 'react';
import styles from './CourseDetail.module.css';
import * as utils from '../../../utils/utils';
import Sidebar from '../../Sidebar/Sidebar';

export default class CourseDetail extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			errorText: '',
			courseID: 0,
			chapterNum: 1,
			courseDetails: null,
			isChapterLoading: false,
			nextChapterUnavailable: false,
		};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		const params = this.getQueryParams();
		if (!params.courseID || !params.chapterNum) {
			this.setState({
				isLoading: false,
				errorText: 'Invalid course reference. Please open a course from the list.',
			});
			return;
		}

		this.setState({
			courseID: params.courseID,
			chapterNum: params.chapterNum,
		}, () => this.loadCourseDetails(false));
	}

	getQueryParams = () => {
		const params = new URLSearchParams(window.location.search);
		const courseID = Number(params.get('courseID'));
		const chapterNum = Number(params.get('chapterNum') || '1');

		return {
			courseID: Number.isInteger(courseID) && courseID > 0 ? courseID : 0,
			chapterNum: Number.isInteger(chapterNum) && chapterNum > 0 ? chapterNum : 1,
		};
	};

	loadCourseDetails = (isChapterSwitch) => {
		const {
			courseID,
			chapterNum,
		} = this.state;

		this.setState({
			isLoading: !isChapterSwitch,
			isChapterLoading: isChapterSwitch,
			errorText: '',
			nextChapterUnavailable: false,
		}, () => {
			utils.sendRequest('/course/getCourseDetails', {
				courseID,
				chapterNum,
			})
				.then((responseData) => {
					this.syncUrlQuery(courseID, chapterNum);
					this.setState({
						isLoading: false,
						isChapterLoading: false,
						courseDetails: responseData.courseDetails || null,
					});
				})
				.catch((error) => {
					const errorMessage = error && error.message ? error.message : 'Could not load course details.';

					if (isChapterSwitch && /not found/i.test(errorMessage)) {
						this.setState({
							isLoading: false,
							isChapterLoading: false,
							nextChapterUnavailable: true,
						});
						return;
					}

					this.setState({
						isLoading: false,
						isChapterLoading: false,
						errorText: errorMessage,
					});
				});
		});
	};

	syncUrlQuery = (courseID, chapterNum) => {
		const query = `?courseID=${courseID}&chapterNum=${chapterNum}`;
		window.history.replaceState(null, '', `/course-detail${query}`);
	};

	onBackToListClick = () => {
		window.location.href = '/my-courses';
	};

	onPrevChapterClick = () => {
		if (this.state.chapterNum <= 1 || this.state.isChapterLoading) {
			return;
		}

		this.setState({
			chapterNum: this.state.chapterNum - 1,
		}, () => this.loadCourseDetails(true));
	};

	onNextChapterClick = () => {
		if (this.state.isChapterLoading) {
			return;
		}

		this.setState({
			chapterNum: this.state.chapterNum + 1,
		}, () => this.loadCourseDetails(true));
	};

	render() {
		const {
			isLoading,
			isChapterLoading,
			errorText,
			courseDetails,
			chapterNum,
			nextChapterUnavailable,
		} = this.state;

		return (
			<div className={styles.pageContainer}>
				<Sidebar />

				<div className={styles.glowTop} />
				<div className={styles.glowBottom} />

				<div className={styles.layoutShell}>
					<section className={styles.headerPanel}>
						<div className={styles.brandBadge}>HQVibe</div>
						<h1 className={styles.title}>{courseDetails ? courseDetails.courseTitle : 'Course Detail'}</h1>
						<p className={styles.subtitle}>
							{courseDetails ? `Mapped to ${courseDetails.itemName || 'your learning item'} for ${courseDetails.jobTitle || 'your job path'}.` : 'Loading course context...'}
						</p>
						<button type='button' className={styles.secondaryButton} onClick={this.onBackToListClick}>Back To Courses</button>
					</section>

					<section className={styles.mainCardPanel}>
						<div className={styles.chapterTopRow}>
							<h2 className={styles.formTitle}>Chapter {chapterNum}</h2>
							<div className={styles.chapterControls}>
								<button
									type='button'
									className={styles.navButton}
									onClick={this.onPrevChapterClick}
									disabled={chapterNum <= 1 || isChapterLoading}
								>
									Previous
								</button>
								<button
									type='button'
									className={styles.primaryButton}
									onClick={this.onNextChapterClick}
									disabled={isChapterLoading}
								>
									Next Chapter
								</button>
							</div>
						</div>

						{
							isLoading
								? <div className={styles.loadingBox}>Loading chapter details...</div>
								: (
									<div className={styles.contentPanel}>
										{
											courseDetails && courseDetails.markdownContent
												? <pre className={styles.markdownContent}>{courseDetails.markdownContent}</pre>
												: <p className={styles.emptyText}>No content available for this chapter yet.</p>
										}
									</div>
								)
						}

						{
							nextChapterUnavailable &&
							<div className={styles.infoBox}>You reached the final available chapter for this course.</div>
						}

						{
							errorText !== '' &&
							<div className={styles.errorBox}>{errorText}</div>
						}
					</section>
				</div>
			</div>
		);
	}
}
